import { Injectable } from '@angular/core';
import { ValidationErrors } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { ValidatorPatterns } from '@shared/validatorpatterns';
import { IPallet, IPalletConfiguration } from '../palletising.service';
import { objectValidator, ObjectValidators, ValidatorMap } from './objectValidator';

@Injectable({ providedIn: 'root' })
export class PalletizingPalletValidationService {
	constructor(private translator: TranslateService) {}

	// The limits mirror the create/update pallet dialog, so an import cannot store values the UI rejects.
	// The dialog inputs carry the OnlyNumbers directive, which strips everything but digits, so every
	// number it produces is a whole number - hence the integer validator on the numeric properties.
	validators(ValidateId: boolean = true): ValidatorMap<IPallet> {
		const configurationValidators: ValidatorMap<IPalletConfiguration> = {
			length: [ObjectValidators.required, ObjectValidators.integer, ObjectValidators.min(1), ObjectValidators.max(10000)],
			width: [ObjectValidators.required, ObjectValidators.integer, ObjectValidators.min(1), ObjectValidators.max(10000)],
			height: [ObjectValidators.required, ObjectValidators.integer, ObjectValidators.min(1), ObjectValidators.max(10000)],
			weight: [ObjectValidators.integer, ObjectValidators.min(1), ObjectValidators.max(10000)],
			maxHeight: [ObjectValidators.integer, ObjectValidators.min(1), ObjectValidators.max(10000)],
			maxWeight: [ObjectValidators.integer, ObjectValidators.min(1), ObjectValidators.max(10000)],
			oversize: [ObjectValidators.integer, ObjectValidators.min(0), ObjectValidators.max(10000)],
			spaceBetween: [ObjectValidators.integer, ObjectValidators.min(1), ObjectValidators.max(10000)],
			maxLayers: [ObjectValidators.integer, ObjectValidators.min(1), ObjectValidators.max(10)],
			active: [],
		};

		const validator: ValidatorMap<IPallet> = {
			name: [ObjectValidators.required, ObjectValidators.maxLength(50), ObjectValidators.pattern(ValidatorPatterns.DanishCharacters, 'masterdata.palletising.pallets.dialog.name.errors.pattern')],
			description: [ObjectValidators.maxLength(100), ObjectValidators.pattern(ValidatorPatterns.DanishCharacters, 'masterdata.palletising.pallets.dialog.description.errors.pattern')],
			zipCodeRule: [ObjectValidators.integer, ObjectValidators.min(0)],
			dimension: [],
			type: [],
			configuration: [ObjectValidators.required, ObjectValidators.object(configurationValidators)],
			self: [],
			meta: [],
		};

		if (ValidateId) {
			validator.self = [ObjectValidators.required];
		}

		return validator;
	}

	validatePallet(pallet: IPallet, ValidateId: boolean = true): Record<string, ValidationErrors> {
		return objectValidator.validateObject(pallet, this.validators(ValidateId), this.translator);
	}
}
